function CareerServicesRequirementCard({ image, title, description }) {
  return (
    <div className="col-12 col-md-4 card-wrapper-outer">
      <div className="card-wrapper d-flex flex-column justify-content-center align-items-center">
      <picture>
        <img src={image} alt="Boy with degree" />
      </picture>
      <h4>{title}</h4>
      <p className="m-0">{description}</p>
      </div>
    </div>
  );
}
export default CareerServicesRequirementCard;
